import { type RefObject, useEffect } from 'react';

export type TermsScrollMode = 'top' | 'bottom' | false;

const FOLLOW_BOTTOM_MS = 500;
const BOTTOM_OFFSET = 40;

export const useScrollOnOpen = (
  ref: RefObject<HTMLElement | null>,
  isOpen: boolean,
  mode: TermsScrollMode
) => {
  useEffect(() => {
    if (!(isOpen && mode)) return;

    if (mode === 'top') {
      const el = ref.current;
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top, behavior: 'smooth' });
      return;
    }

    // Re-scrolls every frame while the expand transition runs; a single scroll
    // measured on open lands short of the final terms height.
    const start = performance.now();
    let frame = 0;
    const followBottom = (now: number) => {
      const el = ref.current;
      if (!el) return;
      const overflow =
        el.getBoundingClientRect().bottom + BOTTOM_OFFSET - window.innerHeight;
      if (overflow > 0) window.scrollBy({ top: overflow, behavior: 'instant' });
      if (now - start < FOLLOW_BOTTOM_MS) {
        frame = requestAnimationFrame(followBottom);
      }
    };
    frame = requestAnimationFrame(followBottom);
    return () => cancelAnimationFrame(frame);
  }, [ref, isOpen, mode]);
};
